import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './hover-menu.module.scss';
import { classNames } from 'tradera/utils/class-names';

class HoverMenu extends Component {
    state = {
        show: false,
        hoverContainer: false
    };

    toggleShow = (show) => {
        window.clearTimeout(this.toggleShowTimeoutId);
        this.toggleShowTimeoutId = window.setTimeout(() => {
            if (this.state.show !== show) {
                this.setState({ show: show });
            }
        }, 10);
    };

    componentDidUpdate(prevProps) {
        if (this.props.showMenu !== prevProps.showMenu) {
            this.toggleShow(this.props.showMenu);
        }
    }

    render() {
        const {
            children,
            className = '',
            noContainerPositioningStyling
        } = this.props;

        return (
            this.state.show && (
                <div
                    className={classNames(
                        {
                            [styles.hoverMenuContainer]:
                                !noContainerPositioningStyling,
                            [styles.hoverMenuContainerNoPositioning]:
                                noContainerPositioningStyling
                        },
                        className
                    )}
                    onMouseLeave={this.props.onMouseLeave || (() => {})}>
                    <nav className={styles.hoverMenuArea}>
                        <div className={styles.hoverMenuAreaContent}>
                            {children}
                        </div>
                    </nav>
                </div>
            )
        );
    }
}

HoverMenu.propTypes = {
    showMenu: PropTypes.bool,
    className: PropTypes.string,
    noContainerPositioningStyling: PropTypes.bool
};

export default HoverMenu;
